var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2525 5.70385V7.30108C17.0466 7.86109 18.3538 9.48523 18.3538 11.4251V16.5677C18.3538 18.9692 16.3628 20.9163 13.9082 20.9163H5.09217C2.6365 20.9163 0.645508 18.9692 0.645508 16.5677V11.4251C0.645508 9.48523 1.95379 7.86109 3.74685 7.30108V5.70385C3.75743 2.59841 6.32953 0.0830078 9.4838 0.0830078C12.6804 0.0830078 15.2525 2.59841 15.2525 5.70385ZM9.50497 1.89451C11.6537 1.89451 13.4002 3.6025 13.4002 5.70385V7.07645H5.59918V5.68314C5.60977 3.59215 7.35626 1.89451 9.50497 1.89451ZM10.4258 15.1402C10.4258 15.6475 10.013 16.0512 9.49438 16.0512C8.98631 16.0512 8.57351 15.6475 8.57351 15.1402V12.8422C8.57351 12.3453 8.98631 11.9416 9.49438 11.9416C10.013 11.9416 10.4258 12.3453 10.4258 12.8422V15.1402Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.d77aa6bb248119b74020e6664efc47ec.svg";
export { ForwardRef as ReactComponent };